<div class="flex-container">
  <div class="flex-item no-grow">
    <div>
      <button (click)="create()" style="font-size: smaller; margin-bottom: 2px">チャットタブを作る</button>
    </div>
    <select style="width: 100%; max-width: 140px" size="10" (change)="onChangeSelectTab($event.target.value)" [ngModel]="selectedTab?.identifier">
      <option *ngFor="let chatTab of chatTabs" value="{{chatTab.identifier}}">{{chatTab.name}}</option>
    </select>
  </div>
  <div class="flex-item">
    <ng-container *ngIf="!isEmpty && selectedTab">
      <div><label><b style="font-size: smaller">タブ名: </b>
        <input style="width: 200px" [(ngModel)]="tabName" placeholder="Name" [attr.disabled]="!isEditable ? '' : null" /></label>
      </div>
      <div style="font-weight: bolder; font-size: smaller; padding-top: 3px">
        <label>
          <input type="checkbox" [(ngModel)]="isUseStandImage" checked="{{isUseStandImage ? 'checked' : ''}}" (change)="isUseStandImage = (isUseStandImage ? true : false)" [attr.disabled]="!isEditable ? '' : null" />
          カットイン、スタンド有効
        </label>
      </div>
      <div style="font-weight: bolder; font-size: smaller; padding-top: 3px">
        <label>
          <input type="checkbox" [(ngModel)]="recieveOperationLogLevel" checked="{{recieveOperationLogLevel > 0 ? 'checked' : ''}}" (change)="recieveOperationLogLevel = (recieveOperationLogLevel > 0 ? 1 : 0)" [attr.disabled]="!isEditable ? '' : null" />
          操作ログを受信する
        </label>
      </div>
      <hr/>
      <div>
        <ng-container *ngIf="!isDeleted">
          <button (click)="upTabIndex()">↑</button>
          <button (click)="downTabIndex()">↓</button>
          <div style="float: right">
          <button (click)="showLogOutput()"><i class="material-icons small-font">history_edu</i>ログ</button>
          <button [disabled]="isSaveing" (click)="save()">
            <div style="position: relative;">
              <div [ngClass]="{'is-hidden': isSaveing}">保存</div>
              <div *ngIf="isSaveing" class="progress">{{progresPercent}}%</div>
            </div>
          </button>
          <button class="danger" (click)="delete()" [attr.disabled]="chatTabs.length <= 1 ? '' : null">削除</button>
          </div>
        </ng-container>
        <ng-container *ngIf="isDeleted">
          <button (click)="restore()">元に戻す</button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="isEmpty">
  <div style="font-size: 12px;">※チャットタブが１つも作成されていません。「チャットタブを作る」からチャットタブを作成することができます。</div>
</ng-container>